import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import './mobile-product-detail-recommend-list-style.scss';
import useIsComDomain from '@src/hooks/useIsComDomain';

import { Loading } from '@atoms';
import ProductListTitle from '@src/componentsNew/ProductListTitle/ProductListTitle';
import MobileRecommendProductThumbnail from '@src/componentsNew/ProductThumbnail/RecommendProductThumbnail/MobileRecommendProductThumbnail';
import SectionDivider from '@src/componentsNew/SectionDivider';

import { RecommendType } from '@components/ProductPage/ProductDetailPage/queries';
import { RECOMMENDED_PRODUCTS } from '@components/ProductPage/ProductDetailRecommendation/queries';
import { recommendedProducts } from '@components/ProductPage/ProductDetailRecommendation/__generated__/recommendedProducts';

import { VisibilityDetector } from '@components/VisibilityDetector';
import { gaV4RecommendedProductExposed, getDBIdFromGraphqlId } from '@utils';
import { TypographyVariant } from '@src/utils/types';
import { getInvisibleProductIds } from '@src/utils/constants';
import { useInvisibleProductIds } from "@src/hooks/useInvisibleProductIds";

interface MobileProductDetailRecommendListProps {
  title: string;
  productId: string;
  recommendType: RecommendType;
  brandUrl?: string;
  titleVariant?: TypographyVariant;
}

const MobileProductDetailRecommendList = ({
  title,
  productId,
  recommendType,
  brandUrl = '',
  titleVariant = 'subtitle1',
}: MobileProductDetailRecommendListProps) => {
  const isComDomain = useIsComDomain();
  const ready = useInvisibleProductIds();

  const { data, loading } = useQuery<recommendedProducts>(RECOMMENDED_PRODUCTS, {
    variables: {
      id: productId,
      type: recommendType,
      limit: 6,
      ...(isComDomain && { isMgs: true }),
    },
    fetchPolicy: 'no-cache',
  });

  if (loading || !ready) {
    return <Loading />;
  }

  return data && data.product.recommendedProducts.length > 0 ? (
    <div className={`mobile-recommend-product-area ${recommendType}`}>
      <ProductListTitle
        title={title}
        typoVariant={titleVariant}
        typoComponent="h6"
        isShowRightBtn={recommendType === RecommendType.Brand}
        rightBtnColor={'#212121'}
        isShowArrow={true}
        url={brandUrl}
      />

      <div className="recommend-product-thumbnail-wrapper">
        {data.product.recommendedProducts
          .filter((recommendedProduct) => {
            return !getInvisibleProductIds().includes(getDBIdFromGraphqlId(recommendedProduct.id)?.toString());
          })
          .map((recommendedProduct, index) => (
            <VisibilityDetector
              key={recommendedProduct.id}
              onVisible={() => {
                gaV4RecommendedProductExposed(
                  getDBIdFromGraphqlId(productId).toString(),
                  getDBIdFromGraphqlId(productId).toString(),
                  index,
                  recommendType,
                );
              }}
            >
              <MobileRecommendProductThumbnail
                product={recommendedProduct}
                productId={productId}
                index={index}
                recommendType={recommendType}
              />
            </VisibilityDetector>
          ))}
      </div>
      {recommendType !== RecommendType.User ? <SectionDivider /> : null}
    </div>
  ) : null;
};

export default MobileProductDetailRecommendList;
